import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'period'
const initialState = {
    list: null,
  }

export const search = createApiAction('periods/search', client.search('/api/setting/periods'))

export const destroy = createApiAction(
  'period/delete',
  client.destroy('/api/setting/periods/:id'),
)

export const get = createApiAction(
  'period/get',
  client.retrieve(`/api/setting/periods/:id`),
)

export const save = createApiAction(
  'period/save',
  client.save('/api/setting/periods'),
)

const update = (state, action) => {
  const found = state.list?.find(rec => rec.id === action.payload.id)
  state.list = found
    ? state.list.map(item => (found.id === item.id ? action.payload : item))
    : [...state.list, action.payload]
}

  const sessionSlice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers(builder) {
      builder
        .addCase(search.fulfilled, (state, action) => {
          state.list = action.payload})
        .addCase(get.fulfilled, update)
        .addCase(save.fulfilled, update)
        .addCase(destroy.fulfilled, (state, action) => {
          state.list = state.list.filter(item => item.id !== action.payload.id)
        })
    },
  })
  
  export default sessionSlice.reducer